import angular from "angular";

angular.module('ui-sentinel.devices.sentinelTracking', [
    'ui-sentinel.devices',
    'ui-sentinel.maps',
    'ui-sentinel.devices.deviceReportToolItem'
]);
